module.exports = __webpack_public_path__ + "img/Training_courses_img_5.23924ce9.jpg";